import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowOutOfBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowOutOfBox"><Path fillRule="evenodd" clipRule="evenodd" d="M5 13.7502V19.0002H19V13.7502H21V21.0002H3V13.7502H5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M12 2.58594L17.9142 8.50015L16.5 9.91436L13 6.41436V16.2502H11V6.41437L7.5 9.91436L6.08579 8.50015L12 2.58594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowOutOfBox;
